export default __webpack_public_path__ + "105ee4948fa0696145ee28b6f4cd077a.svg";